import React, { FC } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';

import { usePermissions } from '@common/providers';
import { ItemList, EmptyList } from '@common/components';
import { CommentsListItem } from '../../components';
import { CommentType } from '@common/store/member-slice/member-comments-slice';

interface CommentsListProps {
  isRTL?: boolean;
  isMobile?: boolean;
  isLoading?: boolean;
  comments?: CommentType[];
  disableActions?: boolean;
  handleOpenItem: (comment: CommentType) => void;
  handleDeleteItem: (commentData: CommentType) => void;
  handleCopyItemLink: (commentUrl: string) => void;
}

const CommentsList: FC<CommentsListProps> = ({
  isRTL,
  isMobile,
  isLoading,
  comments = [],
  disableActions,
  handleDeleteItem,
  handleCopyItemLink,
  handleOpenItem,
}) => {
  const { t } = useTranslation();
  const { can } = usePermissions();

  if (!isLoading && comments.length === 0) {
    return (
      <EmptyList
        title={t('no-comments.title')}
        subTitle={t('no-comments.content')}
      />
    );
  }

  return (
    <div>
      <ItemList
        isMobile={isMobile}
        isLoading={isLoading}
        data={comments || []}
        renderItem={(comment) => {
          const canDeleteComment = can('delete', 'comment', comment);

          return (
            <CommentsListItem
              disableActions={disableActions}
              isRTL={isRTL}
              isMobile={isMobile}
              data={comment}
              handleDeleteItem={canDeleteComment ? handleDeleteItem : undefined}
              handleCopyItemLink={handleCopyItemLink}
              handleOpenItem={handleOpenItem}
            />
          );
        }}
      />
    </div>
  );
};

export default CommentsList;
